// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__XqO4u","text":"NotFound_text__jslFy"};